// @flow

export const LISTINGS_LIST_MAX_WIDTH = 1170;

export const APPRAISABLE_PROPERTY_TYPES = ['HOUSE_APPT', 'HOUSE', 'APPT'];
